import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";

import { User } from "../common/types";
import useListUsers from "../../api/useListUsers";
import UserInfo from "../common/UserInfo";

const Create = () => {
  const { data: allUsers = [], team: allTeams = [] } = useListUsers({});

  const [user, setUser] = useState<User>({
    id: 0,
    type: "users",
    attributes: {
      name: "",
      phone: "",
      email: "",
      title: "",
      roles: [],
      userType: "",
    },
    relationships: {
      teams: {
        data: [],
      },
    },
  });

  const roleOptions = allUsers
    .flatMap((user) => user.attributes.roles || [])
    .reduce((acc, role) => {
      const exists = acc.find((r) => r.value === String(role.id));
      if (role.name && !exists) {
        acc.push({ label: role.name, value: String(role.id) });
      }
      return acc;
    }, [] as { label: string; value: string }[]);

  const teamOptions = allTeams.map((t) => ({
    label: t.attributes.name,
    value: String(t.id),
  }));

  const onSubmit = () => {};

  return (
    <UserInfo
      user={user}
      setUserAttributes={setUser}
      mode="create"
      onSubmit={onSubmit}
      roles={roleOptions}
      team={teamOptions}
      isArchived={false}
    />
  );
};

export default Create;
